/**
 * @file usePreviewBase/constants.js
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 */
import * as config from "config-api";

export const PREVIEW_INDICATOR = "^/preview/";
export const PREVIEW_BASE = config.getString(
    "Client.detailApi.previewImageBase"
);
